import * as Constants from 'const';
import * as Models from 'models';
import { CellEntityType, DefaultFontFamily } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';
import { createLexicalCTAEditor } from '../editors';
import { ArtboardConverterStyles, convertLexicalEditorState } from './convertLexicalEditorState';

type Context = {
  projectType: Constants.ProjectType;
  colors: Models.BrandColorsList;
  fonts: Models.BrandFontsList;
  surfaces: Models.ScreensOrderedMap;
};

export function createCTASchema(
  document: Models.CallToActionMap,
  context: Context,
): Schemas.Text {
  const { projectType, colors, fonts, surfaces } = context;

  const lexicalState = document.get('lexicalState');
  if (!lexicalState) {
    return {
      entityType: CellEntityType.BUTTON,
      paragraphs: [],
    };
  }

  const editor = createLexicalCTAEditor(lexicalState);

  const converterStyles: ArtboardConverterStyles = {
    color: Constants.DefaultCustomStyle.FONT_COLOR as string,
    partColor: Constants.DefaultCustomStyle.FONT_COLOR as string,
    bulletColor: '', // there is no lists in CTA
    fontSize: Constants.DefaultCustomStyle.FONT_SIZE as number,
    fontFamily: DefaultFontFamily,
    lineHeight: Constants.TextLineHeightValue.ONE_POINT_FIFTEEN,
  };

  let paragraphs = convertLexicalEditorState(
    editor.getEditorState(),
    { projectType, colors, fonts, surfaces },
    converterStyles,
  );

  // for CTA with multiple fonts used we are using first font to apply to CTA itself
  paragraphs = paragraphs.map((paragraph: Schemas.TextParagraph) => {
    const firstPartFontFamily = paragraph.segments?.[0]?.parts?.[0]?.fontFamily;

    return {
      ...paragraph,
      fontFamily: firstPartFontFamily ?? paragraph?.fontFamily,
    };
  });

  return { entityType: CellEntityType.BUTTON, paragraphs };
}

